import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
// import { Avatar, Flex, Heading, Text } from '@chakra-ui/react';
import { Flex, FormControl, Input, Button, Text } from '@chakra-ui/react';
// import axios from 'axios';
import api from 'api/axiosConfig';
import API_BASE from 'configs/hostConfig';
// import ChatBottomBar from './ChatBottomBar';
// import { messages } from 'pages/writing/data/messages';

function ChatBox({
  messages,
  preMessage,
  essayId,
  prompt,
  grade,
  essayType,
  section,
  flexibleChat,
}) {
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);

  // Scroll to the bottom of the messages container when new messages are added
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const getMessages = () =>
    messages?.map((msg) => {
      const sender = msg.sender === 'Ivy';
      if (sender || msg.type === 1) {
        return (
          <Flex
            key={Math.random()}
            alignSelf={sender ? 'flex-start' : 'flex-end'}
            bg={sender ? 'green.100' : 'blue.50'}
            w="fit-content"
            minWidth="100px"
            borderRadius="lg"
            p={3}
            m={1}
          >
            <Text>{msg.text}</Text>
            {/* This is a dummy div to scroll into when a new message arrives */}
            <div ref={messagesEndRef} />
          </Flex>
        );
      }
    });

  const sendMessage = async (e) => {
    e.preventDefault();
    const body = {
      question: input,
      exerciseId: essayId,
      writingPrompt: prompt,
      grade,
      essayType,
      section,
    };
    api
      .post(`${API_BASE}/api/chat/writing-question`, body)
      .then((res) => {
        // console.log('======= free chat response: ', res);
        if (res.status == 200) {
          flexibleChat(res.data?.data);
          // todo: update local message storage ?
        }
      })
      .catch(() => console.log('failed to chat with Ivy'))
      .finally(() => {
        setInput('');
      });
  };

  return (
    <Flex flex={1} direction="column" h="560px">
      {/* <Flex bg="gray.100" h="80px" w="100%" align="center" p={5}>
        <Avatar src="" marginEnd={3} />
        <Heading size="md">Instruction from Ivy</Heading>
      </Flex> */}
      {/* <Topbar email={getOtherEmail(chat?.users, user)} /> */}

      <Flex
        flex={1}
        direction="column"
        pt={4}
        mx={1}
        overflowX="scroll"
        sx={{ scrollbarWidth: 'none' }}
      >
        {preMessage && (
          <Flex
            key={Math.random()}
            alignSelf={'flex-start'}
            bg={'green.100'}
            w="fit-content"
            minWidth="100px"
            borderRadius="lg"
            p={3}
            m={1}
          >
            <Text>{preMessage}</Text>
            <div ref={messagesEndRef} />
          </Flex>
        )}
        {getMessages()}
        {/* <div ref={bottomOfChat}></div> */}
      </Flex>

      {/* <ChatBottomBar id={id} user={user} /> */}
      {/* <ChatBottomBar flexibleChat={flexibleChat} /> */}
      <FormControl p={3} onSubmit={sendMessage} as="form">
        <Input
          placeholder="Type a message..."
          autoComplete="off"
          onChange={(e) => setInput(e.target.value)}
          value={input}
        />
        <Button type="submit" hidden>
          Submit
        </Button>
      </FormControl>
    </Flex>
  );
}

ChatBox.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.any).isRequired,
  preMessage: PropTypes.string,
  essayId: PropTypes.string.isRequired,
  prompt: PropTypes.string,
  grade: PropTypes.number,
  essayType: PropTypes.string,
  section: PropTypes.number.isRequired,
  flexibleChat: PropTypes.func,
};

export default ChatBox;
